import { getAppState } from '../../../../../store/configureStore';
import { getSnackbar } from '../../selectors/getSnackbar';

/***
 KNB-4545
 Повторяющиеся снэкбары (например удаление/архивация карты) должны иметь уникальный id, т.к. если id не меняется, то у всех снэкбаров будет:
 1. общий таймер (если таймер 3 сек, и каждую секунду вызвать по снэкбару с тем же id последний скроется сразу же)
 2. onTimer в kui воспроизведется у первого снэкбара удалив текущий
 Поэтому желательно иметь уникальный id и перед вызовом вызовом удалять предыдущий с помощью данного метода
 ***/
export const hideSnackbarIfNeeded = (
    snackbarId: string,
) => {
    if (!snackbarId) return;
    const currentSnackbar = getSnackbar(getAppState(), snackbarId);
    if (!currentSnackbar || !currentSnackbar.onHide) return;
    currentSnackbar.onHide();
};
